import { Industry } from "../../types/industry";
import { apiSlice } from "./apiSlice";

export const industriesSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getIndustries: builder.query<Industry[], void>({
            query: () => `/industries`,
            keepUnusedDataFor: 5,
        }),
        getIndustryById: builder.query<Industry, string>({
            query: (industryId: string) => `/industries/${industryId}`,
            keepUnusedDataFor: 5,
        }),
    })
})

export const { useGetIndustriesQuery, useGetIndustryByIdQuery } = industriesSlice